import { createModel, RematchDispatch } from '@rematch/core';
import { PaginationType } from 'types/common.d';
import { UserType } from 'types/entities/users.d';
import * as usersApi from 'services/users';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'usersEntity';

export const usersEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof usersEntity>) => ({
    async load(payload): Promise<{ content: UserType[] } & PaginationType> {
      try {
        const res = await usersApi.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async findById(payload, state) {
      try {
        const item = state[storeName].ids[payload];
        if (item && !item.isSimplified) {
          return item;
        }
        const res = await usersApi.getById(payload);
        this.saves([res.data]);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        let item;
        if (!payload.id) {
          ({ data: item } = await usersApi.create(payload));
        } else {
          ({ data: item } = await usersApi.update(payload.id, payload));
        }
        this.update(item);
      } catch (e) {
        throw new Error(e);
      }
    },
    async forceChangePassword(payload) {
      try {
        const res = await usersApi.forceChangePassword(payload);
        return res.data;
      } catch (err) {
        throw new Error(err.response.data.message);
      }
    },
  }),
});

export default usersEntity;
